module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible && _vm.hasLink) ? _c('router-link', {
    staticClass: "part-header-deferred",
    class: ("part-header-deferred_" + _vm.type),
    style: (_vm.styles),
    attrs: {
      "to": _vm.to
    }
  }, [_vm._v(_vm._s(_vm.value))]) : (_vm.isVisible) ? _c('div', {
    staticClass: "part-header-deferred"
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65b6a0ee","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/header/deferred/component.vue
// module id = e01458a1c26f5fb10c71
// module chunks = 8